import { FormMultiSelect } from '@ipfabric/ui-components/FormMultiSelect/FormMultiSelect';
import { FormSegmentedButton } from '@ipfabric/ui-components/FormSegmentedButton/FormSegmentedButton';
import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import { FormTextArea } from '@ipfabric/ui-components/FormTextArea/FormTextArea';
import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import { SegmentButton } from '@ipfabric/ui-components/SegmentedButton/SegmentButton/SegmentButton';
import type { SiteSeparationAttributeTransformation } from '@ipfabric/utils/schema/siteSeparation/siteSeparationAttributeTransformation';
import {
  EXCLUDED_WAN_INTERFACES_TOOLTIP_TEXT,
  FIREWALL_AT_SITE_TOOLTIP_TEXT,
  ROUTING_SWITCHING_TRANSFORMATION_TOOLTIP_TEXT,
  type RuleEditorContentProps,
  type RuleEditorValues,
  TRANSFORMATION_OPTIONS,
  WAN_OPTIONS,
} from './RuleEditor.types';

export const RoutingSwitchingRuleEditorContent = ({
  control,
}: RuleEditorContentProps) => (
  <>
    <FormSegmentedButton.Single<
      RuleEditorValues,
      SiteSeparationAttributeTransformation
    >
      control={control}
      label='Text transformation'
      labelTooltip={ROUTING_SWITCHING_TRANSFORMATION_TOOLTIP_TEXT}
      name='transformation'
    >
      {TRANSFORMATION_OPTIONS.map(({ label, value }) => (
        <SegmentButton key={value} value={value} className='flex-1'>
          {label}
        </SegmentButton>
      ))}
    </FormSegmentedButton.Single>
    <FormMultiSelect
      control={control}
      label='Excluded WAN interfaces'
      labelTooltip={EXCLUDED_WAN_INTERFACES_TOOLTIP_TEXT}
      name='wan'
      options={WAN_OPTIONS}
    />
    <FormTextField
      control={control}
      label='Minimum site size'
      min={1}
      name='minimumSiteSize'
      type='number'
    />
    <FormSwitch
      control={control}
      label='Firewall at site'
      labelTooltip={FIREWALL_AT_SITE_TOOLTIP_TEXT}
      name='firewall'
    />
    <FormTextArea
      control={control}
      dataTestId='site-separation-note'
      label='Rule description (optional)'
      name='note'
    />
  </>
);
